module.exports = __webpack_public_path__ + "img/playkids-logo.ae61c983.svg";